'use es6';

import { PureComponent } from 'react';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import UIList from 'UIComponents/list/UIList';
import MenuNodeTypes from 'simple-menus-core/enums/MenuNodeTypes';
import * as MenuTreeActions from 'simple-menus-core/actions/MenuTree';
import UsageTracker from 'simple-menus-lib/utils/usageTracker/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = key => `simpleMenusLib.components.addMenuButton.${key}`;
const mapDispatchToProps = {
  addNodeToBottom: MenuTreeActions.addNodeToBottom
};
const actions = [MenuNodeTypes.NO_LINK, MenuNodeTypes.PAGE_LINK, MenuNodeTypes.PAGE_LINK_WITH_PARAMS, MenuNodeTypes.URL_LINK];
class AddMenuButton extends PureComponent {
  constructor(props) {
    super(props);
    this.onPopoverChange = evt => {
      const {
        value
      } = evt.target;
      this.setState({
        isOpen: value || !this.state.isOpen
      });
    };
    this.closePopover = () => {
      this.setState({
        isOpen: false
      });
    };
    this.handleNodeCreate = type => {
      const {
        addNodeToBottom,
        menuId
      } = this.props;
      addNodeToBottom(menuId, {
        type
      });
      UsageTracker.track('addMenuItem', {
        type,
        method: 'button'
      });
      this.closePopover();
    };
    this.state = {
      isOpen: false
    };
  }
  renderBodyContent() {
    const buttons = actions.map(action => {
      return /*#__PURE__*/_jsx(UIButton, {
        onClick: () => this.handleNodeCreate(action),
        use: "unstyled",
        className: "simple-menus-menu-node-divider-option-button",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey(`actions.${action}`)
        })
      }, action);
    });
    return /*#__PURE__*/_jsx(UIList, {
      className: "p-y-2",
      children: buttons
    });
  }
  render() {
    return /*#__PURE__*/_jsx(UIPopover, {
      open: this.state.isOpen,
      onOpenChange: this.onPopoverChange,
      placement: "bottom",
      content: this.renderBodyContent(),
      closeOnOutsideClick: true,
      children: /*#__PURE__*/_jsx(UIButton, {
        onClick: this.onPopoverChange,
        use: "link",
        size: "small",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('label')
        })
      })
    });
  }
}
export default connect(null, mapDispatchToProps)(AddMenuButton);